<template lang="pug">
.timeline
  .bg
    .bar(:style="barStyle")
</template>

<script>
import TWEEN from '@tweenjs/tween.js'
const Timeline = {
  props: ['percent'],
  data () {
    return {
      indexTime: 0
    }
  },
  mounted () {
    this.indexTime = this.percent
    this.timerIndex()
  },
  components: {

  },
  computed: {
    barStyle () {
      return {
        width: `${this.indexTime}%`
      }
    }
  },
  methods: {
    animate (time) {
      requestAnimationFrame(this.animate)
      TWEEN.update(time)
    },
    timerIndex () {
      let _this = this
      this.animate = new TWEEN.Tween({
        indexTime: 0
      })
      .easing(TWEEN.Easing.Quadratic.Out)
      .to({
        indexTime: 100
      }, 4000)
      .onUpdate(function () {
        _this.indexTime = this.indexTime
      })
      .onComplete(() => {
        _this.indexTime = 0
        _this.timerIndex()
        _this.$emit('reset')
      })
      .start()
    },
    reset () {
      this.animate.stop()
      this.indexTime = 0
      this.timerIndex()
    }
  }
}
export default Timeline
</script>

<style scoped lang="stylus">
@import "../common.styl"
.timeline{
  position: absolute;
  height: 10px;
  .bg{
    position: relative;
    top: 2px;
    height: 2px;
    background-color: #fff;
    .bar{
      position: relative;
      top: -1px;
      height: 6px;
      background-color: $red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// timeline.vue?29ee4811